import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCXSKkjE2UzuX2exo02wZLVSXYeul66SQg",
  authDomain: "laneiq-ae0cd.firebaseapp.com",
  projectId: "laneiq-ae0cd",
  storageBucket: "laneiq-ae0cd.firebasestorage.app",
  messagingSenderId: "87992985444",
  appId: "1:87992985444:web:824b7bd549c698fede7c71"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);